import * as yup from "yup"
import moment from "moment"

export const TPAFormSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    feeType: yup.string().required("Fee type is required"),
    feeAmount: yup
        .number()
        .typeError("Fee amount must be a number")
        .required("Fee amount is required")
        .min(0, "Fee amount must be non-negative"),
    contactName: yup.string().required("Contact name is required"),
    contactEmail: yup.string().email("Invalid email").required("Contact email is required"),
    description: yup.string().nullable(),
})


export const TPAConfigFormSchema = yup.object().shape({
    tpa: yup.string().required("TPA is required"),
    claimType: yup.string().required("Claim type is required"),
    communicationChannel: yup.string().required("Communication channel is required"),
    startDate: yup
        .string()
        .required("Start date is required"),
    endDate: yup
        .string()
        .transform(value => value === "" ? null : value)
        .nullable()
        .test("end-after-start", "End date cannot be before start date", function (value) {
            const { startDate } = this.parent
            if (!value || !startDate) return true
            const start = moment(startDate, "YYYY-MM-DD")
            const end = moment(value, "YYYY-MM-DD")
            return end.isSameOrAfter(start)
        }),
    lineOfBusiness: yup.string().required("Line of business is required"),
})



